import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { IMyDpOptions, IMyDateModel, IMyDate, IMyDayLabels, IMyMonthLabels } from 'mydatepicker';
import { faCalendarCheck, faUserCheck, faTrashAlt, faUserMd } from '@fortawesome/free-solid-svg-icons';
import { faCalendarCheck as farCalendarCheck, faUser, faAddressCard } from '@fortawesome/free-regular-svg-icons';

import { AuthService } from '../../service/auth.service'
import { ToastrService } from 'ngx-toastr';
import { GlobalErrorHandlerService } from '../../service/global-error-handler.service';

import { HealthgroupService } from '../../service/healthgroup.service';
import { SchedulingService } from '../../service/scheduling.service';
import { PatientService } from '../../service/patient.service';
import { SchedulingTypeService } from '../../service/scheduling-type.service';
import { AppointmentTypeService } from '../../service/appointment-type.service';
import { AppointmentService } from '../../service/appointment.service';

import { Patient } from '../../patient/patient';
import { Scheduling } from '../scheduling';
import { SchedulingType } from '../../scheduling-type/scheduling-type';
import { AppointmentType } from '../../appointment/appointment-type';

declare var jQuery: any;

@Component({
  selector: 'mc-scheduling-form',
  templateUrl: './scheduling-form.component.html',
  styleUrls: ['./scheduling-form.component.scss']
})
export class SchedulingFormComponent implements OnInit {

  calendarCheck = faCalendarCheck;
  userCheck = faUserCheck;
  trashAlt = faTrashAlt;
  farCalendarCheck = farCalendarCheck;
  farUser = faUser;
  addressCard = faAddressCard;
  userMd = faUserMd;

  @ViewChild('confirmDeleteSchedulingModal', { static: true }) private confirmDeleteSchedulingModal: ElementRef;
  patient: Patient;
  doctors: any;
  selectedDoctor: any;
  schedulingTypes: SchedulingType[] = [];
  selectedType: SchedulingType;
  selectedDate: Object;
  selectedDateSchedules: Scheduling[] = [];
  schedulingToDelete: Scheduling;
  availableTimes: [] = [];
  selectedTime: any;
  appointmentTypes: AppointmentType[] = [];
  selectedAppointmentType: AppointmentType;
  loadingSchedulings: boolean = false;
  myDpOptions: IMyDpOptions;
  lastAppointmentDate: Date;

  constructor(
    private authService: AuthService,
    private hgService: HealthgroupService,
    private schedulingService: SchedulingService,
    private schedulingTypeService: SchedulingTypeService,
    private patientService: PatientService,
    private appointmentTypeService: AppointmentTypeService,
    private notifService: ToastrService,
    private errorHandler: GlobalErrorHandlerService,
    private route: ActivatedRoute,
    private location: Location,
    private appointmentService: AppointmentService
  ) {
    let today = new Date();
    today.setDate(today.getDate() -1);
    this.myDpOptions = {
      dateFormat: 'dd/mm/yyyy',
      showClearDateBtn: false,
      alignSelectorRight: true,
      satHighlight: true,
      inline: true,
      dayLabels: <IMyDayLabels>{ su: 'Dom', mo: 'Seg', tu: 'Ter', we: 'Qua', th: 'Qui', fr: 'Sex', sa: 'Sab' },
      monthLabels: <IMyMonthLabels>{
        1: 'Jan', 2: 'Fev', 3: 'Mar', 4: 'Abr', 5: 'Mai', 6: 'Jun', 7: 'Jul', 8: 'Ago', 9: 'Set', 10: 'Out', 11: 'Nov', 12: 'Dez'
      }
      // TODO: Decidir a remoção completa deste código
      // ,
      // disableUntil: {
      //   year: today.getFullYear(),
      //   month: today.getMonth() + 1,
      //   day: today.getDate()
      // }
    }
  }

  ngOnInit() {
    this.getPatient();
    this.getDoctors();
    this.getSchedulingType();
    this.getAppointmentType();
    this.getPatientLastAppointment();
  }

  getPatient(): void {
    const id = +this.route.snapshot.paramMap.get('id');
    if (!id) { return; }
    this.patientService.getPatient(id).subscribe(
        patient => this.patient = patient
    );
  }

  getPatientLastAppointment(): void {
    const id = +this.route.snapshot.paramMap.get('id');
    if (!id) { return; }
    this.appointmentService.getLastByPatient(id).subscribe(
        appointment => {
            if (appointment) {
                this.lastAppointmentDate = appointment.date;
            }
        }
    );
  }

  getDoctors(): void {
    this.authService.healthGroupLoaded$.subscribe(
      res =>
        this.hgService.getDoctors(this.authService.healthGroup.id)
         .subscribe(doctors => {
           this.doctors = doctors;
           if (doctors.length > 0) {
             this.selectedDoctor = doctors[0];
           }
         })
    );
  }

  getSchedulingType(): void {
    this.schedulingTypeService.getAll().subscribe(
      types => {
        this.schedulingTypes = types;
        if (types.length > 0) {
          this.selectedType = types[0];
        }
      }
    );
  }

  getAppointmentType(): void {
    this.appointmentTypeService.getAll().subscribe(
      types => {
        this.appointmentTypes = types;
        if (types.length > 0) {
          this.selectedAppointmentType = types[0];
        }
      }
    );
  }

  onSelectedDoctorChanged(): void {
    if (!this.selectedDoctor || !this.selectedDate) { return; }
    this.loadingSchedulings = true;
    this.schedulingService.findByDoctorDate(this.selectedDoctor.id, this.selectedDate['jsdate']).subscribe(appoints => {
        this.selectedDateSchedules = appoints;
        this.loadingSchedulings = false;
    });
  }

  onSelectedDateChanged(event: IMyDateModel) {
    if (!this.selectedDoctor) { return; }

    this.loadingSchedulings = true;
    this.selectedTime = null;
    this.selectedDate = { jsdate: event.jsdate };
    const dateToCheck = this.selectedDate['jsdate'];
    const doctorId = this.selectedDoctor.id;

    this.schedulingService.findByDoctorDate(doctorId, dateToCheck).subscribe(appoints => {
        this.selectedDateSchedules = appoints;
        this.schedulingService.getAvailableTimesByDoctorDate(doctorId, dateToCheck).subscribe(times => {
            this.availableTimes = times;
            this.loadingSchedulings = false;
        });
    });
  }

  onSelectedTimeChanged(): void {
    const timeSplit = this.selectedTime.split(':');
    this.selectedDate['jsdate'].setHours(timeSplit[0], timeSplit[1]);
  }

  confirmSchedulingDelete(id: number): void {
    this.schedulingToDelete = this.selectedDateSchedules.find(s => { return s.id === id; });
    jQuery(this.confirmDeleteSchedulingModal.nativeElement).modal('show');
  }

  deleteScheduling(): void {
    const id = this.schedulingToDelete.id;
    this.schedulingService.deleteScheduling(id).subscribe(
      success => {
        let index = this.selectedDateSchedules.findIndex(sched => { return sched.id == id; });
        this.selectedDateSchedules.splice(index, 1);
        this.notifService.success('Agendamento cancelado');
      },
      error => this.notifService.error(error)
    );
  }

  toggleSchedulingConfirmation(id: number): void {
    this.toggleSchedulingDateProperty(id, 'confirmation', 'Paciente confirmado', 'Confirmação cancelada');
  }

  toggleSchedulingArrival(id: number): void {
    this.toggleSchedulingDateProperty(id, 'arrival', 'Chegada registrada', 'Chegada cancelada');
  }

  private toggleSchedulingDateProperty(id: number, property: string, successMessage: string, errorMessage: string): void {
    let scheduling = this.selectedDateSchedules.find(s => { return s.id === id; });
    let message = successMessage;
    if (scheduling[property]) {
      scheduling[property] = null;
      message = errorMessage;
    } else {
      scheduling[property] = new Date();
    }
    this.schedulingService.updateScheduling(scheduling).subscribe(
      res => { this.notifService.success(message); },
      err => { this.errorHandler.handleError(err); }
    );
  }

  saveScheduling(): void {
    if (!this.patient) { return; }
    if (!this.selectedDoctor) {
        this.notifService.error("Nenhum médico foi informado");
        return;
    }
    if (!this.selectedDate) {
        this.notifService.error("Nenhuma data foi informada");
        return;
    }
    if (!this.selectedTime) {
        this.notifService.error("Nenhum horário foi selecionado");
        return;
    }

    let scheduling: Scheduling = new Scheduling();
    scheduling.patient = this.patient;
    scheduling.whenisit = this.selectedDate['jsdate'];
    scheduling.doctor = this.selectedDoctor;
    scheduling.clinic = this.authService.getSelectedClinic();
    scheduling.schedulingType = this.selectedType;
    scheduling.appointmentType = this.selectedAppointmentType;

    this.schedulingService.createScheduling(scheduling).subscribe(
        sched => {
            this.notifService.success("Agendamento realizado");
            this.location.back();
        },
        error => { this.notifService.error(error); }
    );
  }
}
